import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const CityGuides = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddCityGuide = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditCityGuide = () => {
  return (
    
      
        <Edit />
      
    
  );
};
